import api from '../api';
import apiExternal from '../apiExternal';

function handleResponse(response) {
  if (![200, 201].includes(response.status)) {
    return { errorMessage: response.msg };
  }

  return response.data;
}

// Affiliate
export const getAffiliates = async (params) => {
  const res = await api.get('/api/Affiliate', { onlyActive: false, ...params });
  return handleResponse(res);
};

export const getAffiliate = async (id) => {
  const res = await api.get(`/api/Affiliate/${id}`);
  return handleResponse(res);
};

export const postAffiliate = async (data) => {
  const res = await api.post('/api/Affiliate', data);
  return handleResponse(res);
};

export const putAffiliate = async (data) => {
  const res = await api.put('/api/Affiliate', data);
  return handleResponse(res);
};

export const exportAffiliates = async () => {
  const res = await api.get('/api/Affiliate/export');
  return handleResponse(res);
};

export const importAffiliates = async (data) => {
  const res = await api.post('/api/Affiliate/import', data);
  return handleResponse(res);
};

// AffiliatePump
export const getAffiliatePumps = async (params) => {
  const res = await api.get('/api/AffiliatePump', params);
  return handleResponse(res);
};

export const postAffiliatePump = async (data) => {
  const res = await api.post('/api/AffiliatePump', data);
  return handleResponse(res);
};

export const putAffiliatePump = async (data) => {
  const res = await api.put('/api/AffiliatePump', data);
  return handleResponse(res);
};

export const exportAffiliatePumps = async () => {
  const res = await api.get('/api/AffiliatePump/export');
  return handleResponse(res);
};

export const importAffiliatePumps = async (data) => {
  const res = await api.post('/api/AffiliatePump/import', data);
  return handleResponse(res);
};

// AffiliateTrait
export const getAffiliateTraits = async (params) => {
  const res = await api.get('/api/AffiliateTrait/Paginate', params);
  return handleResponse(res);
};

export const postAffiliateTrait = async (data) => {
  const res = await api.post('/api/AffiliateTrait', data);
  return handleResponse(res);
};

export const putAffiliateTrait = async (data) => {
  const res = await api.put('/api/AffiliateTrait', data);
  return handleResponse(res);
};

export const exportAffiliateTraits = async () => {
  const res = await api.get('/api/AffiliateTrait/export');
  return handleResponse(res);
};

export const exportAffiliateTraitsHistory = async () => {
  const res = await api.get('/api/AffiliateTrait/exportHistory');
  return handleResponse(res);
};

export const importAffiliateTraits = async (data) => {
  const res = await api.post('/api/AffiliateTrait/import', data);
  return handleResponse(res);
};

// ApprovalAuthority
export const getApprovalAuthorities = async (params) => {
  const res = await api.get('/api/ApprovalAuthority', params);
  return handleResponse(res);
};

export const postApprovalAuthority = async (data) => {
  const res = await api.post('/api/ApprovalAuthority', data);
  return handleResponse(res);
};

export const putApprovalAuthority = async (data) => {
  const res = await api.put('/api/ApprovalAuthority', data);
  return handleResponse(res);
};

// ApprovalMargin
export const getApprovalMargins = async (params) => {
  const res = await api.get('/api/ApprovalMargin', params);
  return handleResponse(res);
};

export const postApprovalMargin = async (data) => {
  const res = await api.post('/api/ApprovalMargin', data);
  return handleResponse(res);
};

export const putApprovalMargin = async (data) => {
  const res = await api.put('/api/ApprovalMargin', data);
  return handleResponse(res);
};

// CadFckBrSl
export const getCadFckBrSls = async (params) => {
  const res = await api.get('/api/CadFckBrSl', params);
  return handleResponse(res);
};

export const postCadFckBrSl = async (data) => {
  const res = await api.post('/api/CadFckBrSl', data);
  return handleResponse(res);
};

export const putCadFckBrSl = async (data) => {
  const res = await api.put('/api/CadFckBrSl', data);
  return handleResponse(res);
};

export const exportCadFckBrSls = async () => {
  const res = await api.get('/api/CadFckBrSl/export');
  return handleResponse(res);
};

export const importCadFckBrSls = async (data) => {
  const res = await api.post('/api/CadFckBrSl/import', data);
  return handleResponse(res);
};

// Consumption
export const getConsumptions = async (params) => {
  const res = await api.get('/api/Consumption', params);
  return handleResponse(res);
};

export const postConsumption = async (data) => {
  const res = await api.post('/api/Consumption', data);
  return handleResponse(res);
};

export const putConsumption = async (data) => {
  const res = await api.put('/api/Consumption', data);
  return handleResponse(res);
};

// Delegation
export const getDelegations = async (params) => {
  const res = await api.get('/api/Delegation', params);
  return handleResponse(res);
};

export const postDelegation = async (data) => {
  const res = await api.post('/api/Delegation', data);
  return handleResponse(res);
};

export const putDelegation = async (data) => {
  const res = await api.put('/api/Delegation', data);
  return handleResponse(res);
};

export const exportDelegations = async () => {
  const res = await api.get('/api/Delegation/Export');
  return handleResponse(res);
};

// DiscountRange
export const getDiscountRanges = async (params) => {
  const res = await api.get('/api/DiscountRange', params);
  return handleResponse(res);
};

export const postDiscountRange = async (data) => {
  const res = await api.post('/api/DiscountRange', data);
  return handleResponse(res);
};

export const putDiscountRange = async (data) => {
  const res = await api.put('/api/DiscountRange', data);
  return handleResponse(res);
};

// Factor
export const getFactors = async (params) => {
  const res = await api.get('/api/Factor', params);
  return handleResponse(res);
};

export const postFactor = async (data) => {
  const res = await api.post('/api/Factor', data);
  return handleResponse(res);
};

export const putFactor = async (data) => {
  const res = await api.put('/api/Factor', data);
  return handleResponse(res);
};

// HierarchyPayment
export const getHierarchyPayments = async (params) => {
  const res = await api.get('/api/HierarchyPayment', params);
  return handleResponse(res);
};

export const postHierarchyPayment = async (data) => {
  const res = await api.post('/api/HierarchyPayment', data);
  return handleResponse(res);
};

export const putHierarchyPayment = async (data) => {
  const res = await api.put('/api/HierarchyPayment', data);
  return handleResponse(res);
};

// HierarchyPump
export const getHierarchyPumps = async (params) => {
  const res = await api.get('/api/HierarchyPump', params);
  return handleResponse(res);
};

export const postHierarchyPump = async (data) => {
  const res = await api.post('/api/HierarchyPump', data);
  return handleResponse(res);
};

export const putHierarchyPump = async (data) => {
  const res = await api.put('/api/HierarchyPump', data);
  return handleResponse(res);
};

// HierarchyTrait
export const getHierarchyTraits = async (params) => {
  const res = await api.get('/api/HierarchyTrait', params);
  return handleResponse(res);
};

export const postHierarchyTrait = async (data) => {
  const res = await api.post('/api/HierarchyTrait', data);
  return handleResponse(res);
};

export const putHierarchyTrait = async (data) => {
  const res = await api.put('/api/HierarchyTrait', data);
  return handleResponse(res);
};

// LossCause
export const getLossCauses = async (params) => {
  const res = await api.get('/api/LossCause', params);
  return handleResponse(res);
};

export const postLossCause = async (data) => {
  const res = await api.post('/api/LossCause', data);
  return handleResponse(res);
};

export const putLossCause = async (data) => {
  const res = await api.put('/api/LossCause', data);
  return handleResponse(res);
};

// NegotiationStatus
export const getNegotiationStatuses = async (params) => {
  const res = await api.get('/api/NegotiationStatus/Backoffice', params);
  return handleResponse(res);
};

export const postNegotiationStatus = async (data) => {
  const res = await api.post('/api/NegotiationStatus', data);
  return handleResponse(res);
};

export const putNegotiationStatus = async (data) => {
  const res = await api.put('/api/NegotiationStatus/update', data);
  return handleResponse(res);
};

// OwnConsumption
export const getOwnConsumptions = async (params) => {
  const res = await api.get('/api/OwnConsumption', params);
  return handleResponse(res);
};

export const postOwnConsumption = async (data) => {
  const res = await api.post('/api/OwnConsumption', data);
  return handleResponse(res);
};

export const putOwnConsumption = async (data) => {
  const res = await api.put('/api/OwnConsumption', data);
  return handleResponse(res);
};

export const exportOwnConsumptions = async (data) => {
  const res = await api.put('/api/OwnConsumption/export', data);
  return handleResponse(res);
};

export const importOwnConsumptions = async (data) => {
  const res = await api.post('/api/OwnConsumption/import', data);
  return handleResponse(res);
};

// Parameter
export const getParameters = async (params) => {
  const res = await api.get('/api/Parameter', params);
  return handleResponse(res);
};

export const postParameter = async (data) => {
  const res = await api.post('/api/Parameter', data);
  return handleResponse(res);
};

export const putParameter = async (data) => {
  const res = await api.put('/api/Parameter', data);
  return handleResponse(res);
};

// Payment
export const getPayments = async (params) => {
  const res = await api.get('/api/Payment', params);
  return handleResponse(res);
};

export const postPayment = async (data) => {
  const res = await api.post('/api/Payment', data);
  return handleResponse(res);
};

export const putPayment = async (data) => {
  const res = await api.put('/api/Payment', data);
  return handleResponse(res);
};

export const exportPayments = async (data) => {
  const res = await api.put('/api/Payment/export', data);
  return handleResponse(res);
};

export const importPayments = async (data) => {
  const res = await api.post('/api/Payment/import', data);
  return handleResponse(res);
};

// Player
export const getPlayers = async (params) => {
  const res = await api.get('/api/Player', { onlyActive: false, ...params });
  return handleResponse(res);
};

export const postPlayer = async (data) => {
  const res = await api.post('/api/Player', data);
  return handleResponse(res);
};

export const putPlayer = async (data) => {
  const res = await api.put('/api/Player', data);
  return handleResponse(res);
};

// PriceContract
export const getPriceContracts = async (params) => {
  const res = await api.get('/api/PriceContract', params);
  return handleResponse(res);
};

export const postPriceContract = async (data) => {
  const res = await api.post('/api/PriceContract', data);
  return handleResponse(res);
};

export const putPriceContract = async (data) => {
  const res = await api.put('/api/PriceContract', data);
  return handleResponse(res);
};

// PriceRule
export const getPriceRules = async (params) => {
  const res = await api.get('/api/PriceRule', params);
  return handleResponse(res);
};

export const postPriceRule = async (data) => {
  const res = await api.post('/api/PriceRule', data);
  return handleResponse(res);
};

export const putPriceRule = async (data) => {
  const res = await api.put('/api/PriceRule', data);
  return handleResponse(res);
};

// PriceService
export const getPriceServices = async (params) => {
  const res = await api.get('/api/PriceService', params);
  return handleResponse(res);
};

export const postPriceService = async (data) => {
  const res = await api.post('/api/PriceService', data);
  return handleResponse(res);
};

export const putPriceService = async (data) => {
  const res = await api.put('/api/PriceService', data);
  return handleResponse(res);
};

// Proposal
export const getProposals = async (params) => {
  const res = await api.get('/api/Proposal/Backoffice', params);
  return handleResponse(res);
};

// Pump
export const getPumps = async (params) => {
  const res = await api.get('/api/Pump/Backoffice', params);
  return handleResponse(res);
};

export const postPump = async (data) => {
  const res = await api.post('/api/Pump', data);
  return handleResponse(res);
};

export const putPump = async (data) => {
  const res = await api.put('/api/Pump', data);
  return handleResponse(res);
};

export const exportPumps = async () => {
  const res = await api.get('/api/Pump/export');
  return handleResponse(res);
};

export const importPumps = async (data) => {
  const res = await api.post('/api/Pump/import', data);
  return handleResponse(res);
};

// Recommendation
export const getRecommendations = async (params) => {
  const res = await api.get('/api/Recommendation', params);
  return handleResponse(res);
};

export const postRecommendation = async (data) => {
  const res = await api.post('/api/Recommendation', data);
  return handleResponse(res);
};

export const putRecommendation = async (data) => {
  const res = await api.put('/api/Recommendation', data);
  return handleResponse(res);
};

// RegionalEfficiency
export const getRegionalEfficiencies = async (params) => {
  const res = await api.get('/api/RegionalEfficiency', params);
  return handleResponse(res);
};

export const postRegionalEfficiency = async (data) => {
  const res = await api.post('/api/RegionalEfficiency', data);
  return handleResponse(res);
};

export const putRegionalEfficiency = async (data) => {
  const res = await api.put('/api/RegionalEfficiency', data);
  return handleResponse(res);
};

// Seller
export const getSellers = async (params) => {
  const res = await api.get('/api/Seller', params);
  return handleResponse(res);
};

export const postSeller = async (data) => {
  const res = await api.post('/api/Seller', data);
  return handleResponse(res);
};

export const putSeller = async (data) => {
  const res = await api.put(`/api/Seller/${data.id}`, data);
  return handleResponse(res);
};

export const exportSellers = async () => {
  const res = await api.get('/api/Seller/Export');
  return handleResponse(res);
};

export const importSellers = async (data) => {
  const res = await api.post('/api/Seller/Import', data);
  return handleResponse(res);
};

// Spectra
export const getSpectras = async (params) => {
  const res = await api.get('/api/Spectra', params);
  return handleResponse(res);
};

export const postSpectra = async (data) => {
  const res = await api.post('/api/Spectra', data);
  return handleResponse(res);
};

export const putSpectra = async (data) => {
  const res = await api.put('/api/Spectra', data);
  return handleResponse(res);
};

export const exportSpectras = async () => {
  const res = await api.get('/api/Spectra/export');
  return handleResponse(res);
};

export const importSpectras = async (data) => {
  const res = await api.post('/api/Spectra/import', data);
  return handleResponse(res);
};

// Trait
export const getTraits = async (params) => {
  const res = await api.get('/api/Trait', params);
  return handleResponse(res);
};

export const postTrait = async (data) => {
  const res = await api.post('/api/Trait', data);
  return handleResponse(res);
};

export const putTrait = async (data) => {
  const res = await api.put('/api/Trait', data);
  return handleResponse(res);
};

// TraitFamily
export const getTraitFamilies = async (params) => {
  const res = await api.get('/api/TraitFamily', params);
  return handleResponse(res);
};

export const postTraitFamily = async (data) => {
  const res = await api.post('/api/TraitFamily', data);
  return handleResponse(res);
};

export const putTraitFamily = async (data) => {
  const res = await api.put('/api/TraitFamily', data);
  return handleResponse(res);
};

// WorkOvertime
export const getWorkOvertimes = async (params) => {
  const res = await api.get('/api/WorkOvertimeSap', params);
  return handleResponse(res);
};

export const postWorkOvertime = async (data) => {
  const res = await api.post('/api/WorkOvertimeSap', data);
  return handleResponse(res);
};

export const putWorkOvertime = async (data) => {
  const res = await api.put('/api/WorkOvertimeSap', data);
  return handleResponse(res);
};

export const calculatePriceRule = async (params) => {
  const res = await api.get('/api/Affiliate/calculatePriceRule', {
    params,
  });

  return handleResponse(res);
};

export const getCities = async (uf) => {
  const res = await apiExternal.get(`https://servicodados.ibge.gov.br/api/v1/localidades/estados/${uf}/municipios?orderBy=nome`);

  if (Array.isArray(res.data)) {
    res.data = res.data.map((el) => ({ value: el.id, label: el.nome }));
  }

  return handleResponse(res);
};

export const getAffiliateDistancePrices = async (params) => {
  const res = await api.get('/api/AffiliateDistancePrices', params);
  return handleResponse(res);
};

export const postAffiliateDistancePrice = async (data) => {
  const res = await api.post('/api/AffiliateDistancePrices', data);
  return handleResponse(res);
};

export const putAffiliateDistancePrice = async (data) => {
  const res = await api.put('/api/AffiliateDistancePrices', data);
  return handleResponse(res);
};
